export const PossibleTagsDict = {

	getContractTags() {
		return contractTags;
	},

	getDonationContractTags() {
		return donationContractTags;
	},

	getCorrespondenceTags() {
		return correspondenceTags;
	}

};

let contractTags = [
	"SUMAKONTROLNA",
	"PLNAZWAPODMIOTU",
	"NIP",
	"KRS",
	"ADRESPODMIOTUMIEJSCOWOSC",
	"KORESPONDENCYJNYADRESPODMIOTUMIEJSCOWOSC",
	"ADRESPODMIOTUKODPOCZTOWY",
	"KORESPONDENCYJNYADRESPODMIOTUKODPOCZTOWY",
	"ADRESPODMIOTUULICA",
	"KORESPONDENCYJNYADRESPODMIOTUULICA",
	"ADRESPODMIOTUNRDOMU",
	"KORESPONDENCYJNYADRESPODMIOTUNRDOMU",
	"ADRESPODMIOTUNRLOKALU",
	"KORESPONDENCYJNYADRESPODMIOTUNRLOKALU",
	"OSOBAUPRAWNIONAIMIE",
	"OSOBAUPRAWNIONANAZWISKO",
	"OSOBAUPRAWNIONAFUNKCJA",
	"NRPROJEKTU",
	"PLNAZWAPROJEKTU",
	"DATAPOCZATKUPROJEKTUZPROJEKTU",
	"DATAKONCAPROJEKTUZPROJEKTU",
	"KOSZTCALKOWITYKWOTAZPROJEKTU",
	"DOTACJAKWOTAZPROJEKTU",
	"WKLADWLASNYKWOTAZPROJEKTU",
	"WKLADOSOBOWYKWOTAZPROJEKTU",
	"WKLADRZECZOWYKWOTAZPROJEKTU",
	"STOSUNEKWKLADUWLASNEGODODOTACJIWARTOSCZPROJEKTU",
	"DATAPOCZATKUWYKORZYSTANIADOTACJI",
	"DATAKONCAWYKORZYSTANIADOTACJI",
	"DATAPOCZATKUWYKORZYSTANIAWKLADUWLASNEGO",
	"DATAKONCAWYKORZYSTANIAWKLADUWLASNEGO",
	"DATAWYGENEROWANIA",
	"GODZINAWYGENEROWANIA",
	"DATAIGODZINAWYGENEROWANIA"
];

let donationContractTags = [
	"SUMAKONTROLNA",
	"PLNAZWAPODMIOTU",
	"PLNAZWAPROJEKTU",
	"DATAPOCZATKUPROJEKTUZPROJEKTU",
	"DATAKONCAPROJEKTUZPROJEKTU",
	"KOSZTCALKOWITYKWOTAZPROJEKTU",
	"WKLADWLASNYKWOTAZPROJEKTU",
	"DOTACJAKWOTAZPROJEKTU",
	"NRUMOWY",
	"NRANEKSU",
	"DATAUMOWY",
	"DATAANEKSU",
	"ZATWIERDZONADOTACJA",
	"ZATWIERDZONYWKLADWLASNY",
	"KOSZTCALKOWITYZESPRAWOZDANIA",
	"DOTACJAZESPRAWOZDANIA",
	"WKLADWLASNYZESPRAWOZDANIA",
	"ODSETKIBANKOWEZESPRAWOZDANIA",
	"INNEPRZYCHODYZESPRAWOZDANIA",
	"DATAPOCZATKUWYKORZYSTANIADOTACJI",
	"DATAKONCAWYKORZYSTANIADOTACJI",
	"DATAPOCZATKUWYKORZYSTANIAWKLADUWLASNEGO",
	"DATAKONCAWYKORZYSTANIAWKLADUWLASNEGO",
	"DATAWYGENEROWANIA",
	"GODZINAWYGENEROWANIA",
	"DATAIGODZINAWYGENEROWANIA"
];

let correspondenceTags = [
	"SUMAKONTROLNA",
	"PLNAZWAPODMIOTU",
	"NIP",
	"KRS",
	"ADRESPODMIOTUMIEJSCOWOSC",
	"KORESPONDENCYJNYADRESPODMIOTUMIEJSCOWOSC",
	"ADRESPODMIOTUKODPOCZTOWY",
	"KORESPONDENCYJNYADRESPODMIOTUKODPOCZTOWY",
	"ADRESPODMIOTUULICA",
	"KORESPONDENCYJNYADRESPODMIOTUULICA",
	"ADRESPODMIOTUNRDOMU",
	"KORESPONDENCYJNYADRESPODMIOTUNRDOMU",
	"ADRESPODMIOTUNRLOKALU",
	"KORESPONDENCYJNYADRESPODMIOTUNRLOKALU",
	"OSOBAUPRAWNIONAIMIE",
	"OSOBAUPRAWNIONANAZWISKO",
	"OSOBAUPRAWNIONAFUNKCJA",
	"NRPROJEKTU",
	"PLNAZWAPROJEKTU",
	"DATAPOCZATKUPROJEKTUZPROJEKTU",
	"DATAKONCAPROJEKTUZPROJEKTU",
	"KOSZTCALKOWITYKWOTAZPROJEKTU",
	"DOTACJAKWOTAZPROJEKTU",
	"WKLADWLASNYKWOTAZPROJEKTU",
	"WKLADOSOBOWYKWOTAZPROJEKTU",
	"WKLADRZECZOWYKWOTAZPROJEKTU",
	"STOSUNEKWKLADUWLASNEGODODOTACJIWARTOSCZPROJEKTU",
	"NRUMOWY",
	"NRANEKSU",
	"DATAUMOWY",
	"DATAANEKSU",
	"ZATWIERDZONADOTACJA",
	"ZATWIERDZONYWKLADWLASNY",
	"KOSZTCALKOWITYZESPRAWOZDANIA",
	"DOTACJAZESPRAWOZDANIA",
	"WKLADWLASNYZESPRAWOZDANIA",
	"ODSETKIBANKOWEZESPRAWOZDANIA",
	"INNEPRZYCHODYZESPRAWOZDANIA",
	"DATAPOCZATKUWYKORZYSTANIADOTACJI",
	"DATAKONCAWYKORZYSTANIADOTACJI",
	"DATAPOCZATKUWYKORZYSTANIAWKLADUWLASNEGO",
	"DATAKONCAWYKORZYSTANIAWKLADUWLASNEGO",
	"DATAWYGENEROWANIA",
	"GODZINAWYGENEROWANIA",
	"DATAIGODZINAWYGENEROWANIA"
];
